module.exports = "https://preprod.web-phone.apps.phone.com/static/media/pdc-logo.7bb4fe18.svg";